/**
 * Auth (public) routes — moved verbatim from router/index.tsx.
 */

import { type RouteObject } from 'react-router-dom';
import { ROUTES } from '@/constants';
import { lazyWithRetry } from '@/utils/lazyWithRetry';

// Auth pages
const LoginPage = lazyWithRetry(() => import('@/features/auth/pages/LoginPage'));
const RegisterPage = lazyWithRetry(() => import('@/features/auth/pages/RegisterPage'));
const ForgotPasswordPage = lazyWithRetry(() => import('@/features/auth/pages/ForgotPasswordPage'));
const ResetPasswordPage = lazyWithRetry(() => import('@/features/auth/pages/ResetPasswordPage'));

export const authRoutes: RouteObject[] = [
      {
        path: ROUTES.auth.login,
        element: <LoginPage />,
      },
      {
        path: ROUTES.auth.register,
        element: <RegisterPage />,
      },
      {
        path: ROUTES.auth.forgotPassword,
        element: <ForgotPasswordPage />,
      },
      {
        path: ROUTES.auth.resetPassword,
        element: <ResetPasswordPage />,
      },
];
